import { WorkDocsFolder } from 'src/services/WorkDocsService';
import { findSubfolderIdByName } from './readinessCheckUtils';

/**
 * Resolves the WorkDocs folder id a Step 3 how-to guide should open its in-page upload modal
 * for. Matches the guide's named subfolder (e.g. "Prior Cycle Baseball Cards") against the
 * root's loaded child listing.
 *
 * Returns `null` when the id isn't known yet — either the root isn't provisioned, or the folder
 * tree hasn't listed the root's children yet (it lists lazily). The caller then renders the
 * folder name as plain text (no upload button) rather than opening a modal for a missing folder.
 *
 * @param folderName        The subfolder's exact display name (e.g. MANAGER_HUB_EXPORTS_FOLDER).
 * @param rootFolderId      This quarter's provisioned root folder id, or null if not set up.
 * @param rootChildFolders  The root's direct child folders (from the browser hook's cache);
 *                          empty until the root listing loads.
 */
export function resolveFolderId(folderName: string, rootFolderId: string | null, rootChildFolders: WorkDocsFolder[]): string | null {
  if (!rootFolderId) return null;
  return findSubfolderIdByName(rootChildFolders, folderName) ?? null;
}
